import { InjectionToken } from '@angular/core';

export const BASE_API_URL = new InjectionToken<string>('BASE_API_URL');
export const PGAAS_API_URL = new InjectionToken<string>('PGAAS_API_URL');
export const PUBLIC_PGAAS_API_URL = new InjectionToken<string>('PUBLIC_PGAAS_API_URL');
